<template>
  <div class="login-page">
    <app-navbar-login></app-navbar-login>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image" data-color="green">
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <card type="login">
                <p>{{ progressText }}</p>
                <p v-bind:class="{ websphereShow: isHidden }">
                  <router-link :to="{name: 'Login'}">Click here to login to your account</router-link>
                </p>
              </card>
            </div>
          </div>
        </div>
        <app-footer-login></app-footer-login>
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import auth from 'src/auth'

  import {Card, Button} from 'src/components/UIComponents';
  import AppNavbarLogin from './Layout/AppNavbarLogin'
  import AppFooterLogin from './Layout/AppFooterLogin'
  export default {
    components: {
      Card,
      AppNavbarLogin,
      AppFooterLogin,
      [Button.name]: Button
    },
    data () {
      return {
        progressText: 'Verifying...',
        isHidden: true
      }
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      verifyEmail () {

        this.$http.get('/email/verify/' + this.$route.query.task, {
          params: {
            signature: this.$route.query.signature,
            expires: this.$route.query.expires
          }
        })
        .then(response=>{
          if(response.data == "Verification successful!") {
            this.progressText =  'Verification successful!'
            this.isHidden = false
            auth.logout()
          } else if (response.status == 204){
            this.progressText = "Your email is already verified!"
            this.isHidden = false
            auth.logout()
          }else {
            this.progressText = "We could not verify your email address."
          }
        })
        .catch(error =>{
          this.progressText = "Something went wrong and we could not verify your email address."
        })
      }
    },
    beforeDestroy () {
      this.closeMenu()
    },

    mounted () {
      this.verifyEmail ()
    }
  }
</script>
<style>
.login-page .content .container { margin-top: 0px !important; margin-left: 0px;}
.ml-auto, .mx-auto { margin-left: 0px !important; }
.login-page #websphereCoded {margin-left: 40px !important;}
.login-page .h3, .login-page h3 {margin-bottom: 0px; line-height: normal }
.websphere-show {display: none}
</style>
